import { render, staticRenderFns } from "./TagsManagerListItem.vue?vue&type=template&id=8f78deb6&scoped=true&"
import script from "./TagsManagerListItem.vue?vue&type=script&lang=js&"
export * from "./TagsManagerListItem.vue?vue&type=script&lang=js&"
import style0 from "./TagsManagerListItem.vue?vue&type=style&index=0&id=8f78deb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f78deb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VIcon,VMenu,VSwitch,VTooltip})
